var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLease = function SvgLease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 46 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lease_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#040404",
    fillOpacity: 0.03,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34BCCC",
    d: "M40.026-6.556a1 1 0 0 1 1.414 0L54.169 6.172a4 4 0 0 1 0 5.657l-4.717 4.718L33.187.283z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lease_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 55,
    x: 3.5,
    y: 3.5,
    stroke: "#E9E9E9",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 22,
    y: 52,
    fill: "#9F9F9F",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 22,
    y: 32,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    x: 22,
    y: 35,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    x: 22,
    y: 38,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    x: 22,
    y: 41,
    fill: "#E4E4E4",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0DAFC3",
    fillOpacity: 0.84,
    d: "M16 53.858H8.727V52.54h6.169v-3.203H16zm.107-7.622q0 .82-.341 1.417-.345.593-.973.912-.633.32-1.488.32-.842 0-1.478-.32a2.4 2.4 0 0 1-.994-.902q-.359-.579-.359-1.36 0-.504.164-.952.16-.45.497-.795.337-.348.86-.547.518-.2 1.235-.199h.394v4.471h-.866v-3.239a1.4 1.4 0 0 0-.657.16 1.16 1.16 0 0 0-.458.437q-.168.277-.167.646 0 .394.192.693.187.298.497.465.305.164.67.167h.757q.477 0 .817-.174.337-.174.519-.487.177-.312.177-.731 0-.28-.078-.508a1.1 1.1 0 0 0-.238-.394 1 1 0 0 0-.387-.252l.135-1.2q.476.113.83.433.353.315.548.81.192.492.192 1.129m.003-4.683q0 .519-.185.934-.188.412-.554.653-.365.239-.902.238-.461 0-.763-.17a1.3 1.3 0 0 1-.483-.465 2.4 2.4 0 0 1-.273-.664 5.4 5.4 0 0 1-.139-.77 31 31 0 0 0-.089-.779q-.042-.298-.127-.433-.089-.138-.274-.138H12.3q-.402 0-.622.238t-.22.685q0 .472.206.75.206.272.487.369l-.17 1.2a1.9 1.9 0 0 1-.832-.469 2.04 2.04 0 0 1-.504-.799 3 3 0 0 1-.17-1.044q0-.394.092-.785.092-.39.305-.714.21-.323.572-.518.362-.2.905-.199H16v1.236h-.75v.043a1.57 1.57 0 0 1 .743.859q.117.316.117.742m-.944-.334q0-.388-.153-.67a1.13 1.13 0 0 0-.412-.438 1.05 1.05 0 0 0-.558-.156h-.642q.049.06.092.206.042.142.075.32.031.177.056.351l.043.302q.04.288.128.515.089.227.248.359.158.13.405.131.356 0 .536-.26.181-.258.181-.66m-3.179-7.75.128 1.172a.9.9 0 0 0-.334.174.9.9 0 0 0-.252.327 1.2 1.2 0 0 0-.096.504q0 .402.174.675.175.27.451.266a.47.47 0 0 0 .387-.174q.15-.181.245-.596l.2-.93q.166-.775.528-1.151.363-.38.949-.384.515.004.909.302.39.295.61.82t.22 1.208q0 1.001-.419 1.612-.422.61-1.175.728l-.12-1.254a.88.88 0 0 0 .557-.362q.188-.277.188-.72 0-.459-.188-.736-.188-.28-.465-.28a.49.49 0 0 0-.387.18q-.153.18-.235.555l-.195.93q-.164.784-.55 1.161-.39.377-.988.373a1.4 1.4 0 0 1-.873-.273 1.8 1.8 0 0 1-.576-.778 3 3 0 0 1-.206-1.154q0-.959.409-1.51.408-.553 1.104-.685m4.12-3.192q0 .821-.341 1.417-.345.594-.973.913-.633.32-1.488.32-.842 0-1.478-.32a2.4 2.4 0 0 1-.994-.902q-.359-.58-.359-1.36 0-.504.164-.952.16-.45.497-.795.337-.349.86-.547.518-.2 1.235-.199h.394v4.47h-.866v-3.238a1.4 1.4 0 0 0-.657.16 1.16 1.16 0 0 0-.458.437q-.168.276-.167.646 0 .394.192.693.187.298.497.465.305.163.67.167h.757q.477 0 .817-.174.337-.174.519-.487.177-.312.177-.731 0-.281-.078-.508a1.1 1.1 0 0 0-.238-.394 1 1 0 0 0-.387-.252l.135-1.2q.476.113.83.433.353.315.548.81.192.493.192 1.128"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lease_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 62,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lease_svg__b",
    width: 42,
    height: 58,
    x: 2,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_532_254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_532_254",
    result: "shape"
  })))));
};
export default SvgLease;